import { Agent } from '../../models/Agent/Agent'
import { CallClassificationOption } from '../../models/CallClassificationOption'
import { Department } from '../../models/Departments/Department'
import { Source } from '../../models/Source'
import { Action } from '../Actions'

const ACTION_SET_SOURCES = 'SET_SOURCES'
const ACTION_SET_DEPARTMENTS = 'SET_DEPARTMENTS'
const ACTION_SET_CALL_CLASSIFICATION_OPTIONS = 'SET_CALL_CLASSIFICATION_OPTIONS'
const ACTION_SET_MAIN_WIDTH = 'SET_MAIN_WIDTH'
const ACTION_SET_AGENT = 'SET_AGENT'

const initialState: CrmState = {
    agent: new Agent(),
    sources: [], 
    departments: [],
    callClassificationOptions: [],
    mainComponentWidth: 0
}

export interface CrmState {
    agent: Agent
    sources: Source[]
    departments: Department[]
    callClassificationOptions: CallClassificationOption[]
    mainComponentWidth: number
}

export class CrmActions {
    static setDepartments = (departments: Department[]): Action => ({ type: ACTION_SET_DEPARTMENTS, payload: { departments: departments } })
    static setSources = (sources: Source[]): Action => ({ type: ACTION_SET_SOURCES, payload: { sources: sources } })
    static setCallClassificationOptions = (options: CallClassificationOption[]): Action => ({ type: ACTION_SET_CALL_CLASSIFICATION_OPTIONS, payload: { options: options } })
    static setMainWidth = (width: number): Action => ({ type: ACTION_SET_MAIN_WIDTH, payload: { width: width } })
    static setAgent = (agent: Agent): Action => ({ type: ACTION_SET_AGENT, payload: { agent: agent } })
}

export function reduce(state: CrmState = initialState, action: Action) {
    switch (action.type) {
        case ACTION_SET_DEPARTMENTS: {
            return {
                ...state,
                departments: action.payload.departments
            }
        }
        case ACTION_SET_SOURCES: {
            return {
                ...state,
                sources: action.payload.sources
            }
        }
        case ACTION_SET_CALL_CLASSIFICATION_OPTIONS: {
            return {
                ...state,
                callClassificationOptions: action.payload.callClassificationOptions
            }
        }
        case ACTION_SET_MAIN_WIDTH: {
            return {
                ...state,
                mainComponentWidth: action.payload.width
            }
        }
        case ACTION_SET_AGENT: {
            return {
                ...state,
                agent: action.payload.agent
            }
        }
        default:
            return state;
    }
}
